import { getURLsearchParams } from '@agritask/js-utils/libs/url';
import { getDefaultBrowserLanguage } from '../utils/getDefaultBrowserLanguage';
export function getPreferredLanguage(route, supportedLangs) {
    const onlyLanguagesCodes = supportedLangs.map((lang) => lang.value);
    const urlParams = getURLsearchParams(window.location.search);
    const urlLang = urlParams.lang;
    if (urlLang && onlyLanguagesCodes.includes(urlLang))
        return urlLang;
    return getDefaultBrowserLanguage(onlyLanguagesCodes);
}
